'use client'

import { createContext, useContext, type ReactNode } from 'react'
import type { PaywallPricingPolicies } from '@/server/domain/quoted-price'

const PaywallPricingContext = createContext<PaywallPricingPolicies | null>(null)

export function PaywallPricingProvider({ policies, children }: {
  policies: PaywallPricingPolicies
  children: ReactNode
}) {
  return <PaywallPricingContext.Provider value={policies}>{children}</PaywallPricingContext.Provider>
}

export function usePaywallPricingPolicies(): PaywallPricingPolicies {
  const policies = useContext(PaywallPricingContext)
  if (!policies) throw new Error('PaywallPricingProvider is required')
  return policies
}
